import { Nilable } from "@shared/utils";
import { obtenerIdRangoEdad, obtenerIdsRangoEdad, RangosEdadEnum, TipoEstudioEnum } from "@shared/enums";
import { PaisDTO } from "./Pais.DTO";

export interface IPanelPayloadDTO {
    marcaPrincipal: string;
    nse: string[];
    factorVelocidad: number;
    duracion: number;
    costo: number;
    pregunta: { [key: string]: any };
    tipoEstudio: number;
    grupoEdades: string[];
    genero: string;
    paises: string[];
    combo_id: Nilable<number>;
    periodo: Nilable<string>;
}

export class PanelPayloadDTO {
    public marcaPrincipal = "";
    public nse: string[] = [];
    public factorVelocidad = 0;
    public duracion = 0;
    public costo = 0;
    public pregunta: { [key: string]: any } = {};
    public tipoEstudio: TipoEstudioEnum = TipoEstudioEnum.BRAND_PENETRATION;
    public edades: RangosEdadEnum[] = [];
    public genero = "";
    public pais = new PaisDTO();
    public comboId = 0;
    public periodo: Nilable<Date> = null;

    constructor(json: Nilable<Partial<IPanelPayloadDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPanelPayloadDTO>) {
        if (json.marcaPrincipal != null) {
            this.marcaPrincipal = json.marcaPrincipal;
        }
        if (json.nse != null) {
            this.nse = json.nse;
        }
        if (json.factorVelocidad != null) {
            this.factorVelocidad = json.factorVelocidad;
        }
        if (json.duracion != null) {
            this.duracion = json.duracion;
        }
        if (json.costo != null) {
            this.costo = json.costo;
        }
        if (json.pregunta != null) {
            this.pregunta = json.pregunta;
        }
        if (json.tipoEstudio != null) {
            this.tipoEstudio = json.tipoEstudio as TipoEstudioEnum;
        }
        if (json.grupoEdades != null) {
            const edadesMap = new Map<string, RangosEdadEnum>();
            obtenerIdsRangoEdad().forEach(([clave, valor]) => edadesMap.set(valor, clave));
            this.edades = json.grupoEdades.map(grupoEdad =>
                edadesMap.get(grupoEdad) ?? RangosEdadEnum[grupoEdad]
            ).filter(Boolean);
        }
        if (json.genero != null) {
            this.genero = json.genero;
        }
        if (json.paises != null) {
            this.pais = new PaisDTO({ code: json.paises[0] });
        }
        if (json.combo_id != null) {
            this.comboId = json.combo_id;
        }
        if (json.periodo != null) {
            this.periodo = new Date(json.periodo);
        }
    }

    public obtenerJSON(): IPanelPayloadDTO {
        return {
            costo: this.costo,
            combo_id: this.comboId,
            duracion: this.duracion,
            factorVelocidad: this.factorVelocidad,
            nse: this.nse,
            genero: this.genero,
            grupoEdades: this.edades.map(rangoEdad => obtenerIdRangoEdad(rangoEdad)),
            marcaPrincipal: this.marcaPrincipal,
            pregunta: this.pregunta,
            tipoEstudio: this.tipoEstudio as number,
            paises: [this.pais.codigo],
            periodo: this.periodo?.toJSON() ?? null
        };
    }
}
